export const onDialogClose = dialogType => ({
  widget: 'tokens',
  type: 'onDialogClose',
  payload: { dialogType },
})



// WEBPACK FOOTER //
// ./src/tokens/actions/onDialogClose.js